import { z } from "zod";
/**
 * Departure address (adresse de départ de tournée) settings.
 *
 * The departure point is the current member's `CompanyMemberSettings.homeAddress`
 * — the SAME point used for travel expenses (frais de déplacement). A single
 * departure geometry is shared between frais and the RDV engine (see the RDV ADR,
 * Q-départ). This module exposes/edits that address; it does NOT introduce a new
 * entity field.
 */
export const UpdateDepartureAddressPayloadSchema = z
    .object({
    streetAddress: z.string().trim().min(1, "L'adresse est requise"),
    streetAddress2: z.string().trim().optional(),
    zipCode: z
        .string()
        .trim()
        .regex(/^\d{5}$/, "Le code postal doit contenir 5 chiffres"),
    city: z.string().trim().min(1, "La ville est requise"),
    /**
     * Trio pin manuel (#941, pattern #929 sur `Customer`) — présence-based :
     * absent du payload = aucune opinion, ne pas toucher au pin existant ;
     * `geocodeSource: null` explicite = retrait (voir `DepartureAddressService.update`).
     * Pas de `.default()` (doctrine anti-`preserve-on-omit`, #507) : un défaut
     * masquerait la distinction absent/null dont le backend dépend.
     */
    // Bornes GPS valides — un pin manuel n'est protégé par aucune comparaison au texte côté serveur.
    latitude: z.number().min(-90).max(90).nullable().optional(),
    longitude: z.number().min(-180).max(180).nullable().optional(),
    /**
     * Restreint à `"manual"` (pas le `GeocodeSource` complet) : `"geo-portail"`
     * est assigné par le SERVEUR seul — l'accepter en entrée permettrait à un
     * appelant qui rejoue une réponse `GET` de purger un pin manuel existant.
     */
    geocodeSource: z.literal("manual").nullable().optional(),
})
    .refine((data) => data.geocodeSource !== "manual" || (data.latitude != null && data.longitude != null), { message: "Un pin manuel doit porter des coordonnées", path: ["geocodeSource"] });
//# sourceMappingURL=departureAddress.types.js.map